import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import Header from "../../component/loaderComponent/Header/Header";
import "./redemptionlimit.scss";
import { useDispatch } from "react-redux";
import { remptionlistAction, postredemptionlistAction, userTypelistAction } from "../../actions/redemptionAction";
import { dowloadredemptionAction } from "../../actions/exceldownloadAction";
import { notify } from '../../services/notification';
import Validation from "../../constants/validation/Validation";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import moment from 'moment';
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT,HTTP_STATUS } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";



function RedemptionLimit() {
  const [states, setStates] = useState({
    minimum_points: ""
  });
  const [redemptionlimit, setRedemptionLimit] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  const [userType, setUserType] = useState("");
  const {  isSidebarOpen, toggleSidebar } = useMobileView();

  const [loading, setloading] = useState(false);
 
  const originalDate = redemptionlimit.created_at;
  const formattedDate = moment(originalDate).utc().format('DD/MM/YYYY');
  const dispatch = useDispatch();
  useEffect(() => {
    getRedemptionlimit();
    getUserTypeList();
  }, []);

  const handleUserTypeChange = (event) => {
    setUserType(event.target.value);
  };
  const handleChange = (evt) => {
    const { name, value } = evt.target;

    setStates({
      ...states,
      [name]: value.replace(/^ +/gm, ""),
    });
  };

  async function getRedemptionlimit() {
    setloading(true);
    var response = await dispatch(remptionlistAction());
    if (response?.status === HTTP_STATUS.CREATED || response?.status === HTTP_STATUS.OK) {
      setRedemptionLimit(response.data.data)
      setloading(false);
    } else if (response === undefined) {
      setloading(false);
    }

  }

  async function getUserTypeList() {
    setloading(true);
    var response = await dispatch(userTypelistAction());
    if (response?.status === HTTP_STATUS.OK) {
      setUserTypeList(response.data.data)
      setloading(false);
    } else if (response === undefined) {
      setloading(false);
    }

  }

  const handleOnCreateClick = async () => {
    setloading(true);
    const apiReq = {
      minimum_points: states.minimum_points,
      user_type_id: userType
    }
    let response = await dispatch(postredemptionlistAction(apiReq));
    if (response?.status === HTTP_STATUS.CREATED) {
      notify.success(response?.data?.messsge)
      setStates({
        minimum_points: "",

      });
      setUserType("");
      getRedemptionlimit();
      setloading(false);
    } else if (response === undefined) {
      setloading(false);
    }
  }

  async function downloadRedemptionLimit() {
    try {
      const fileBlob = await dispatch(dowloadredemptionAction());

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          notify.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  return (
    <div className="redemption-limit-container">
      <div className="redemption-limit-rightsidebar">
        <Header title="Redemption Limit" />
        {loading ? <Loader /> : (
          <div className="reedemption-limit-input-label">
            <div className="reedemption-search">
              <div className="reedemption-label">
                <label className="label-redemption-limit">Redemption Limit</label>
                <input type="text" className="redemption-limit-input" maxLength={3} placeholder="Add redemption limit" name="minimum_points" value={states.minimum_points} onChange={handleChange} onKeyPress={(e) => Validation.numberinputValidator(e)} />
                <select name="criteria" id="cars" className="text_fileddropdowns" 
                value={userType} onChange={handleUserTypeChange}
                >
                    <option value="">Select User Type</option>
                    {userTypeList && userTypeList?.map((item)=>(
                      <option key={item.slug} value={item.id}>{item.user_type}</option>
                    ))}
                </select>
                <button
                  type="button"
                  className="redemption-limit-create-button"
                  onClick={handleOnCreateClick}
                  disabled={!states.minimum_points || !userType}
                >
                  Create
                </button>
                <button className="download-excel" onClick={downloadRedemptionLimit}>
                  <img src={Image_Url.EXCEL_LOGO} className="download-img-excel" />
                  Download log in Excel
                </button>
              </div>
            </div>
            <div className="table-redemption-limit">
              <div className="table-wrapper">
                <table className="table">
                  <tr>
                    <th className="tablesth">Active redemption limit</th>
                    <th className="tablesth">Created on</th>
                    <th className="tablesth">Created by </th>
                    <th className="tablesth">User Type</th>
                  </tr>
                  {redemptionlimit && redemptionlimit?.map((item)=>( 
                  <tr>
                    <td className="tabletd">{item.minimum_points}</td>
                    <td className="tabletd">{item?.created_at && moment(item.created_at).utc().format('DD/MM/YYYY')}</td>
                    <td className="tabletd">{item.admin_user_name}</td>
                    <td className="tabletd">{item.user_type}</td>
                  </tr>
                  ))}
                </table>
              </div>
            </div>
          </div>)}
      </div>
    </div>
  );
}
export default RedemptionLimit;